<template>
    <div :class="className" :style="{height:height,width:width}"></div>
</template>

<script>
import echarts from "echarts";

export default {
  props: {
    className: {
      type: String,
      default: "pieChart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions({ wxData, appData, aliData } = {}) {
      this.chart.setOption({
        series: [
          {
            type: "pie",
            radius: '50%',
            center: ['50%', '35%'],
            itemStyle: {
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
            data: [{ value: wxData.val, name: wxData.name }, { value: appData.val, name: appData.name}, { value: aliData.val, name: aliData.name}]
          }
        ]
      });
    },
    initChart() {
        this.chart = echarts.init(this.$el)
        this.setOptions(this.chartData)
    }
  }
};
</script>
<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components/pieAreaEchart.vue